export const USER_MANAGEMENT_FEATURE_KEY = 'user-management';
